import { ISelectOption } from 'shell-models-lib';

export enum Direction {
    Input = 'Input',
    Output = 'Output',
    InputOutput = 'InputOutput'
}

export const directionOptions: Array<ISelectOption<Direction>> = [
    {
        label: Direction.Input,
        value: Direction.Input
    },
    {
        label: Direction.Output,
        value: Direction.Output
    },
    {
        label: Direction.InputOutput,
        value: Direction.InputOutput
    }
];

export const typeOptions: Array<ISelectOption<string>> = [
    {
        label: 'Byte[]',
        value: 'Byte[]'
    },
    {
        label: 'Boolean',
        value: 'Boolean'
    },
    {
        label: 'Datetime',
        value: 'Datetime'
    },
    {
        label: 'Datetimeoffset',
        value: 'Datetimeoffset'
    },
    {
        label: 'Decimal',
        value: 'Decimal'
    },
    {
        label: 'Double',
        value: 'Double'
    },
    {
        label: 'Guid',
        value: 'Guid'
    },
    {
        label: 'Int16',
        value: 'Int16'
    },
    {
        label: 'Int32',
        value: 'Int32'
    },
    {
        label: 'Int64',
        value: 'Int64'
    },
    {
        label: 'Single',
        value: 'Single'
    },
    {
        label: 'String',
        value: 'String'
    },
    {
        label: 'Timespan',
        value: 'Timespan'
    }
];